import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="read-more"
export default class extends Controller {
  static targets = [ "content", "readMoreButton" ]

  connect() {
    this.toggleReadMoreButton();
    this.readMoreText = this.readMoreButtonTarget.getElementsByClassName("read-more-text")[0];
    this.readLessText = this.readMoreButtonTarget.getElementsByClassName("read-less-text")[0];
    this.windowWidth = window.innerWidth;
  }

  toggleContent() {
    if (this.contentTarget.classList.contains("line-clamp-[5]")) {
      this.contentTarget.classList.remove("line-clamp-[5]");
      this.readMoreText.classList.add("hidden");
      this.readLessText.classList.remove("hidden");
    } else {
      this.contentTarget.classList.add("line-clamp-[5]");
      this.readMoreText.classList.remove("hidden");
      this.readLessText.classList.add("hidden");
    }
  }

  toggleReadMoreButton() {
    if (window.innerWidth === this.windowWidth) { return; }

    this.windowWidth = window.innerWidth;

    if (this.contentTarget.scrollHeight > this.contentTarget.clientHeight && this.readMoreButtonTarget.classList.contains("hidden")) {
      this.readMoreButtonTarget.classList.remove("hidden");
    } else if (this.contentTarget.scrollHeight <= this.contentTarget.clientHeight && !this.readMoreButtonTarget.classList.contains("hidden")) {
      this.readMoreButtonTarget.classList.add("hidden");
    }
  }
}
